/*eslint max-lines: ["error", 600]*/

/**
 *  Module for updating the OMS fields on recipe.
 *
 */
const _ = require('lodash');
const omsRelations = {
  left_chest_monogram: ['oms_tx1', 'oms_tx6'],
  // left_chest_monogram -> oms_tx1 & oms_tx6
  hat_front_monogram: ['oms_tx1', 'oms_tx6'],
  // hat_front_monogram -> oms_tx1 & oms_tx6
  center_chest_monogram: ['oms_tx6'],
  // center_chest_monogram -> oms_tx6
  name_only_monogram: ['oms_tx1'],
  // name_only_monogram -> oms_tx1
  name_and_date_monogram_line_1: ['oms_tx1'],
  name_and_date_monogram_line_2: ['oms_tx2'],
  // name_and_date_line_1 -> oms_tx1
  // name_and_date_line_2 -> oms_tx2
  center_monogram: ['oms_tx1'],
  // center_monogram -> oms_tx1
  corner_monogram: ['oms_tx1'],
  // corner_monogram -> oms_tx1
  right_hem_monogram: ['oms_tx2'],
  // right_hem_monogram -> oms_tx2
  hat_back_monogram: ['oms_tx2'],
  // hat_back_monogram -> oms_tx2
  name_entry_on_back: ['oms_tx4'],
  // name_entry_on_back -> oms_tx4
  number_entry_on_back: ['oms_tx5', 'oms_ct5'],
  // number_entry_on_back -> oms_ct5 & oms_tx5
  monogram_text_entry: ['oms_tx1']
};

const omsMonogramLocations = ['oms_tx1', 'oms_tx6', 'oms_tx2'];
const omsParentRelations = {
  left_chest: [{
    // has to be on this category.
    category: 'clothes', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['none', 'small_pony', 'big_pony', 'dual_match_pony', 'dog_patch', 'bear_patch', 'crest', 'monogram_crest'],
    // copy selected from:
    from: 'left_chest_thread_color',
    to: 'oms_tc1'
  }, {
    // has to be on this category.
    category: 'clothes', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['monogram', 'big_monogram'],
    // copy selected from:
    from: 'left_chest_monogram_embroidery_color',
    to: 'oms_tc1'
  }, {
    // has to be on this category.
    category: 'clothes', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['center_pony'],
    // copy selected from:
    from: 'center_chest_thread_color',
    to: 'oms_tc1'
  }],
  corner: [{
    // has to be on this category.
    category: 'non-clothing',
    // has to be one of:
    vendorId: ['non-clothing-corner'],
    // copy selected from:
    from: 'corner_monogram_embroidery_color',
    to: 'oms_tc1'
  }],
  name_and_date: [{
    // has to be on this category.
    category: 'non-clothing', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['non-clothing-name_and_date'],
    // copy selected from:
    from: 'name_and_date_monogram_embroidery_color',
    to: 'oms_tc1'
  }],
  name_only: [{
    // has to be on this category.
    category: 'non-clothing', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['non-clothing-name_only'],
    // copy selected from:
    from: 'name_only_monogram_embroidery_color',
    to: 'oms_tc1'
  }],
  center: [{
    // has to be on this category.
    category: 'non-clothing',
    // has to be one of:
    vendorId: ['non-clothing-center'],
    // copy selected from:
    from: 'center_monogram_embroidery_color',
    to: 'oms_tc1'
  }],
  right_hem: [{
    // has to be on this category.
    category: 'clothes', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['vintage_year'],
    // copy selected from:
    from: 'right_hem_thread_color',
    to: 'oms_tc2'
  }, {
    // has to be on this category.
    category: 'clothes', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['monogram'],
    // copy selected from:
    from: 'right_hem_monogram_embroidery_color',
    to: 'oms_tc2'
  }, {
    // has to be on this category.
    category: 'clothes', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['small_pony'],
    // copy selected from:
    from: 'right_hem_thread_color',
    to: 'oms_tc2'
  }],
  hat_front: [{
    // has to be on this category.
    category: 'accessories', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['bear_patch_baby_baseball_cap', 'small_pony', 'big_pony', 'dual_match_pony', 'flag', 'dog_patch', 'bear_patch', 'crest', 'monogram_crest'],
    // copy selected from:
    from: 'hat_front_thread_color',
    to: 'oms_tc1'
  }, {
    // has to be on this category.
    category: 'accessories', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['monogram', 'big_monogram'],
    // copy selected from:
    from: 'hat_front_monogram_embroidery_color',
    to: 'oms_tc1'
  }],
  hat_back: [{
    // has to be on this category.
    category: 'accessories', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['small_pony'],
    // copy selected from:
    from: 'hat_back_thread_color',
    to: 'oms_tc2'
  }, {
    // has to be on this category.
    category: 'accessories', // or polos or however you want to call them.
    // has to be one of:
    vendorId: ['monogram'],
    // copy selected from:
    from: 'hat_back_monogram_embroidery_color',
    to: 'oms_tc2'
  }],
  monogram_location: [{
    vendorId: ['front_left', 'front_right', 'back_center'],
    from: 'monogram_embroidery_color',
    to: 'oms_tc1'
  }]
};

const omsTextConflicts = {
  left_chest: {
    vendorId: ['center_pony']
  }
};

const allowedAlias = Object.keys(omsRelations);
const allowedParentAlias = Object.keys(omsParentRelations);

// Array with all the vendorId for the adult products.
const ADULTS = 'LGNMBR';
const NOT_ADULTS = 'MDNMBR';

const updateRecipeOms = function (app) {
  /**
   *  Private Properties/Methods
   */
  const configure = app.configure;

  const getNamesAndMonograms = () => {
    const type = _.clone(app.helpers.getSelectedValueByAlias('names_and_monograms'));

    if (type.vendorId.indexOf('_default') >= 0) {
      type.vendorId = type.vendorId.replace('_default', '');
    }

    return type;
  };

  function updateParentOms(parentAliasAllowed) {
    if (!app.helpers.hasAttribute(parentAliasAllowed)) {
      return;
    }

    if (app.appUtils.isNonClothingProduct()) {
      const type = getNamesAndMonograms();

      if (type.vendorId !== 'none') {
        const omsRelation = _.head(omsParentRelations[type.vendorId]);
        const selected = app.helpers.getSelectedValueByAlias(omsRelation.from);

        configure.run('selectValue', omsRelation.to, { vendorId: selected.vendorId }, app._callback);
        if (app.mergedParams.showOmsUpdates) {
          console.log('OMS UPDATES: \nSelecting AV with vendorId:', selected.vendorId, '\nfrom CA with alias:', omsRelation.from, '\nto CA with alias:', omsRelation.to);
        }
      }
    } else {
      const selectedParent = app.helpers.getSelectedValueByAlias(parentAliasAllowed);

      if (selectedParent) {
        omsParentRelations[parentAliasAllowed].map(function (omsParentRelation) {
          const allowedVendorId = omsParentRelation.vendorId.indexOf(selectedParent.vendorId) !== -1;

          if (allowedVendorId) {
            const selectedAV = app.helpers.getSelectedValueByAlias(omsParentRelation.from);
            configure.run('selectValue', omsParentRelation.to, { vendorId: selectedAV.vendorId }, app._callback);
            if (app.mergedParams.showOmsUpdates) {
              console.log('OMS UPDATES: \nSelecting AV with vendorId:', selectedAV.vendorId, '\nfrom CA with alias:', omsParentRelation.from, '\nto CA with alias:', omsParentRelation.to);
            }
          }
        });
      }
    }
  }
  function getCTValue(text) {
    // Mens and Women -> LGNMBR
    // boys and girls ->MDNMBR
    let result = NOT_ADULTS;
    if (app.utils.getFirstProductFacet('audience', app.product) === 'adult') {
      result = ADULTS;
    }
    return result + text;
  }

  const omsMenuNormalizing = (selectedValue, attribute) => {
    if (!selectedValue || !attribute) {
      return;
    }

    const menuOmsRelations = {
      'name_on_back': { 'oms': 'oms_tx4', 'input': 'name_entry_on_back', 'empty': 'none' }
    };

    if (menuOmsRelations.hasOwnProperty(attribute.alias) && menuOmsRelations[attribute.alias].empty !== selectedValue.vendorId) {
      const omsAlias = menuOmsRelations[attribute.alias].oms;
      const inputAlias = menuOmsRelations[attribute.alias].input;
      const omsValue = configure.run('getAttribute', { alias: omsAlias }).value.text;
      const inputValue = configure.run('getAttribute', { alias: inputAlias }).value.text;

      if (omsValue !== inputValue) {
        configure.run('selectValue', { 'ca': { 'alias': omsAlias }, 'av': { 'text': inputValue } });
      }
    }
  };

  function updateOmsTcBeforeCart() {
    const renderableAliases = app.helpers.getRenderableAttributes(true).map(function (attr) {
      return attr.alias;
    });

    allowedParentAlias.map(function (alias) {
      if (renderableAliases.indexOf(alias) !== -1) {
        updateParentOms(alias);
      }
    });
  }
  const verifyOmsCt5 = () => {
    const recipe = configure.run('getRecipe', 'custom', 'alias');
    const oms_ct5 = recipe.oms_ct5;
    const validVendorIds = ADULTS + NOT_ADULTS;
    if (oms_ct5 && oms_ct5.vendorId && validVendorIds.indexOf(oms_ct5.vendorId) === -1) {
      configure.run('selectValue', 'oms_ct5', { vendorId: getCTValue(recipe.number_entry_on_back.text) }, app._callback);
    }
  };
  function isAliasInProduct(alias) {
    return app.helpers.getRenderableAttributes(true).map(function (attr) {
      return attr.alias;
    }).indexOf(alias) !== -1;
  }
  function isVendorIdNone(alias) {
    const attr = app.helpers.getSelectedValueByAlias(alias);
    return attr.vendorId && attr.vendorId.toLowerCase() === 'none';
  }
  function isVendorIdMonogram(alias) {
    if (!app.helpers.hasAttribute(alias)) { return; }
    return /monogram/.test(app.helpers.getSelectedValueByAlias(alias).vendorId);
  }

  function isConflictingOmsText(parentAlias) {
    return parentAlias && omsTextConflicts[parentAlias] &&
      isAliasInProduct(parentAlias) &&
      omsTextConflicts[parentAlias].vendorId.indexOf(app.helpers.getSelectedValueByAlias(parentAlias).vendorId) !== -1;
  }

  function updateOmsClearChanges(omsClearChanges, alias) {
    omsRelations[alias].map(function (omsAlias) {
      if (/tx/.test(omsAlias)) {
        omsClearChanges.push({
          ca: { alias: omsAlias },
          av: { text: '' }
        });
      }
    });
    return omsClearChanges;
  }
  function clearResidualOmsText() {
    let omsClearChanges = [];
    allowedAlias.map(function (alias) {
      let parentAlias = '';
      if (/_entry/.test(alias)) {
        parentAlias = alias.replace('_entry', '');
        if (isAliasInProduct(parentAlias) && isVendorIdNone(parentAlias)) {
          // we need to clear the text on the CA
          omsClearChanges = updateOmsClearChanges(omsClearChanges, alias);
        }
      } else if (/_monogram/.test(alias)) {
        parentAlias = alias.replace('_monogram', '');

        if (isAliasInProduct(parentAlias) && !isVendorIdMonogram(parentAlias) && !isConflictingOmsText(parentAlias) && !app.appUtils.isNonClothingProduct()) {
          // we need to clear the text on the CA
          omsClearChanges = updateOmsClearChanges(omsClearChanges, alias);
          // and the store.
          app.actions.storeInitials('', parentAlias);
        }
      }
    });
    if (app.mergedParams.showOmsUpdates) {
      console.log('OMS UPDATES: \n', omsClearChanges);
    }

    configure.run('setRecipe', omsClearChanges, app._callback);
  }

  function updateOms(alias, change) {
    if (!change.av) {
      // we need the change to have av.
      return;
    }

    const omsChanges = [];
    omsRelations[alias].map(function (omsAlias) {
      let avChange = change.av;
      if (omsAlias === 'oms_ct5') {
        if (avChange.text && _.isNumber(+avChange.text) && !isNaN(+avChange.text)) {
          avChange = { vendorId: getCTValue(avChange.text) };
        } else {
          return;
        }
      } else if (omsMonogramLocations.indexOf(omsAlias) !== -1) {
        const absoluteParent = (app.appUtils.isSimpleCYO()) ?
          app.monogram.baseAlias(change.ca.alias) :
          change.ca.alias.replace('_monogram', '');
        const storedInitials = app.store.initials();
        if (!storedInitials.hasOwnProperty(absoluteParent)) {
          return;
        }
        avChange = { text: storedInitials[absoluteParent] };
      }
      omsChanges.push({
        ca: { alias: omsAlias },
        av: avChange
      });
    });
    if (app.mergedParams.showOmsUpdates) {
      console.log('OMS UPDATES: \n', JSON.stringify(omsChanges, null, 2));
    }

    configure.run('setRecipe', omsChanges, app._callback);
  }
  function isParentAllowed(alias) {
    let allowed = false;
    allowedParentAlias.map(function (parentAlias) {
      if (alias.indexOf(parentAlias) !== -1) {
        allowed = parentAlias;
      }
    });
    return allowed;
  }
  function updateOmsFields(changes) {
    const change = _.filter(changes, function (o) {
      return allowedAlias.indexOf(o.ca.alias) !== -1;
    });
    const parentChange = _.find(changes, function (o) {
      return isParentAllowed(o.ca.alias);
    });

    if (!change && !parentChange) {
      return;
    }

    if (change) {
      _.forEach(change, (c) => {
        const alias = c.ca.alias;
        updateOms(alias, c);
      });
    }
    if (parentChange) {
      const newAlias = parentChange.ca.alias;
      const parentAlias = isParentAllowed(newAlias);
      updateParentOms(parentAlias);
    }
  }

  function getNonClothingOmsText() {
    const type = getNamesAndMonograms();

    if (type.vendorId !== 'none') {
      const md = app.utils.getMetaData(type);
      const numLines = _.parseInt(md.numlines);
      const oms = {};

      if (numLines > 1) {
        _.times(numLines, (num) => {
          const line = num + 1;
          const data = app.configure.run('getAttribute', {
            alias: `${type.vendorId}_monogram_line_${line}`
          });

          oms[`oms_tx${line}`] = data.value.text;
        });
      } else {
        const monogram = app.configure.run('getAttribute', {
          alias: `${type.vendorId}_monogram`
        });
        oms.oms_tx1 = monogram.value.text;
      }

      return oms;
    }
  }

  function init() {
    configure.on('recipe:loaded', updateOmsFields);
    configure.on('recipe:change', updateOmsFields);
  }
  /**
   *  Expose Public Properties/Methods
   */
  return {
    init,
    updateOms,
    updateOmsFields,
    omsMenuNormalizing,
    clearResidualOmsText,
    updateOmsTcBeforeCart,
    verifyOmsCt5,
    getNonClothingOmsText
  };
};

module.exports = updateRecipeOms;
